@if (filterData()) {
	<div class="wrapper" (click)="onClick('filter')" [attr.data-notification-badge]="badgeCount() || ''">
		<div>{{ 'ui.filtering-data.panel.filter' | translate }}</div>
		<div class="icon">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height="20"
				width="20">
				<path d="M2.5 15.833V14.083H7.667V15.833ZM2.5 5.917V4.167H10.771V5.917ZM9.208 17.5V12.438H10.958V14.083H17.5V15.833H10.958V17.5ZM5.917 12.542V10.875H2.5V9.125H5.917V7.479H7.667V12.542ZM9.208 10.875V9.125H17.5V10.875ZM12.333 7.562V2.5H14.083V4.167H17.5V5.917H14.083V7.562Z"/>
			</svg>
		</div>
	</div>
}
@if (sortData()) {
	<div class="wrapper" (click)="onClick('sort')">
		<div>{{ 'ui.filtering-data.panel.sort' | translate }}</div>
		<div class="icon">
			<svg
				class="rotate"
				xmlns="http://www.w3.org/2000/svg"
				height="20"
				width="20">
				<path d="M14.125 10.917 12.896 9.688 15 7.583H2.521V5.833H15L12.896 3.729L14.125 2.5L18.333 6.708ZM5.875 17.5 1.667 13.292 5.875 9.083 7.104 10.333 5.021 12.417H17.479V14.167H5.021L7.104 16.271Z"/>
			</svg>
		</div>
	</div>
}

<skl-filter-drawer #filterDrawer (resetAll)="onReset()">
	<skl-filter-chips [options]="filterData()?.filterOptions!" [showAll]="true" />
</skl-filter-drawer>
